export const customizeColumn = {
  MULTI_STUDY_PARTICIPATION: 'case_id',
  DOCUMENT_DOWNLOAD: 'access_file',
  numberOfCases: 'numberOfCases',
  studyDesignation: 'clinical_study_designation',
  Description: 'description',
  Cohort: 'does',
  Arm: 'arm',
  ArmDescription: 'armDescription',
  DataValue: 'dataValue',
  csvDataRow: 'csvDataRow',
  clinicalDataNode: 'clinicalDataNode',
  clinicalDataDescription: 'clinicalDataDescription',
  participantCount: 'participantCount',
  recordCount: 'recordCount',

  STUDY_CODE: 'study_id',
  ADDITIONAL_CRDC_NODES: 'unique_repository'

};

// Body Cell
export const customizeLandScapeView = {
  PARTICIPANT_FILES: 'participant_file_count',
  STUDY_FILES: 'study_file_count',
  IMAGE_COLLECTION_COUNT: 'image_collection_count',
  PUBLICATIONS: 'numberOfPublications',
  ADDITIONAL_CRDC_NODES: 'unique_repository'
};

export const customizeHeader = {
  DELETE: 'DELETE',

  PARTICIPANT_FILES: 'participant_file_count',
  STUDY_FILES: 'study_file_count',
  IMAGE_COLLECTION_COUNT: 'image_collection_count',
  PUBLICATIONS: 'numberOfPublications',
  ADDITIONAL_CRDC_NODES: 'unique_repository'
};
